import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { FormControlLabel, MenuItem, Select } from '@mui/material';
import { RoleEnum } from '~/api/types';
import { useAddMemberMutation, useGetNewMembersQuery, useRemoveMemberMutation } from '~/api/v2/hooks';

const AddNewMemberForm = () => {
  const projectId = +useParams().projectid!;
  const { data: newMembersData, isFetching: isFetchingNewMembers } = useGetNewMembersQuery({ projectId });
  const [addMember, { isLoading: isCreatingProjectRole }] = useAddMemberMutation({
    fixedCacheKey: `add-member-${projectId}`,
  });
  const [, { isLoading: isDeletingProjectRole }] = useRemoveMemberMutation({
    fixedCacheKey: `remove-member-${projectId}`,
  });

  const isLoading = isCreatingProjectRole || isFetchingNewMembers || isDeletingProjectRole;

  const { control, handleSubmit, reset, watch } = useForm({
    defaultValues: { id: '' },
  });

  const selectedId = watch('id');

  const onSubmit = async (data: { id: string }) => {
    await addMember({
      projectId,
      role_id: RoleEnum.READER,
      user_id: data?.id,
    });
    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ flex: 1 }}>
      <FormControlLabel
        control={
          <Controller
            name="id"
            control={control}
            rules={{ required: true }}
            disabled={isLoading}
            render={({ field }) => (
              <Select {...field}>
                {newMembersData?.map(({ id, first_name, last_name, profile }) => (
                  <MenuItem key={id} value={id}>
                    {`${first_name} ${last_name} (${profile?.NTID})`}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        }
        label="ADD NEW MEMBER"
      />
      {selectedId && (
        <CustomButton
          type="submit"
          disabled={isLoading}
          label="Submit new user"
          style={{ marginTop: '2rem', textTransform: 'capitalize' }}
        />
      )}
    </form>
  );
};

export default AddNewMemberForm;
